import { Skeleton, Stack, Stepper, Text } from '@chakra-ui/react';
import { useTranslations } from 'use-intl';

import { SubscriptionInfosFragment, useGetActivitiesQuery } from '@blockpulse3/graphql/hooks';
import { ErrorQueryCard } from '@blockpulse3/ui/commons';

import { Activity } from './Activity';

type Props = {
  subscriptionId: SubscriptionInfosFragment['id'];
};

/**
 * SubscriptionDetailsActivityFeed.
 * Activity feed section of the subscription side panel.
 *
 * @param {Props}
 * @returns {JSX.Element}
 */
export function SubscriptionDetailsActivityFeed({ subscriptionId }: Props): JSX.Element {
  const i18nSubscriberDetailsSidePanel = useTranslations('SubscriberDetailsSidePanel');

  const { data, loading, error } = useGetActivitiesQuery({ variables: { subscriptionId } });

  if (error) {
    return <ErrorQueryCard h="60px" mx="3" />;
  }

  const activities = data?.activities || [];

  return (
    <Stack px="4" spacing="4">
      <Text color="gray.600" fontWeight="600">
        {i18nSubscriberDetailsSidePanel('Activity.Title')}
      </Text>
      {loading ? (
        <Skeleton h="60px" />
      ) : (
        <Stepper gap="0" index={-1} orientation="vertical" w="100%">
          {activities.length === 0 ? (
            <Text color="gray.500" fontSize="xs">
              {i18nSubscriberDetailsSidePanel('Activity.NoData')}
            </Text>
          ) : (
            activities.map((activity, index) => (
              <Activity
                key={index}
                data={activity.data}
                date={activity.createdAt}
                type={activity.type}
              />
            ))
          )}
        </Stepper>
      )}
    </Stack>
  );
}

export type SubscriptionDetailsActivityFeedProps = Props;
